import { Modal, Grid, Button } from '@design-systems/canvas-ui'
import { getRfiTagValues } from '../../../common/common'

const RFIErrorModal = (props) => {
  return (
    <Modal
      id="modal-rfi-error-notification"
      isOpen={props.isVisible}
      size="sm"
      onClose={() => props.closeErrorDialog()}
      className="lcm-rfi-error-modal"
      headingText={
        <span className="lcm-rfi-error__heading hc8-clr-error">
          {props.heading}
        </span>
      }
    >
      <p
        id="modal-text-rfi-error-message"
        data-testid="modal-text-rfi-error-message"
        dangerouslySetInnerHTML={{
          __html: [getRfiTagValues('errorMessages')?.validationErrorMessage],
        }}
        className="lcm-rfi-error__message hc8-fs-100 hc8-lh-body hc8-mb-none hc8-ph-6x hc8-pt-4x hc8-pb-2x"
      />
      {/* Action Buttons */}
      <Grid.Container
        id="container-rfi-form-actions"
        className="lcm-modal-actions hc8-ph-6x hc8-pb-4x"
      >
        <Button
          id="button-rfi-error-ok"
          className="popup-button"
          variant="primary"
          size="md"
          onClick={() => {
            props.closeErrorDialog()
          }}
        >
          OK
        </Button>
      </Grid.Container>
    </Modal>
  )
}

export default RFIErrorModal
